import type React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CreateCDWizard } from '../components/wizard';

const CreateCDPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId') ?? undefined;

  return <CreateCDWizard orderId={orderId} />;
};

export default CreateCDPage;
